import React from 'react'
import { Global, css } from '@emotion/react'
import tinycolor from 'tinycolor2'

import Header from './components/Header'
import Main from './components/Main'
import Footer from './components/Footer'
import Base from './Base'

// Component
const Template2 = (props) => {
  const accentColor = props.invoiceSettings.accentColor
  const colors = tinycolor(accentColor).monochromatic(10)
  console.log('colors', colors)
  return (
    <Base {...props}>
      <Global
        styles={css`
          .invoice-details .label,
          .invoice-totals .total-amount td,
          .description .label,
          .note .label {
            color: ${props.invoiceSettings.accentColor};
          }
          .invoice-information .invoice-information-content .invoice-details {
            background: ${tinycolor(accentColor).setAlpha(0.03).toRgbString()};
          }

          .invoice-details, .invoice-totals td{
            // color: ${tinycolor(accentColor).setAlpha(1).toRgbString()};
          }

          .invoice-details {
            border-radius: 0.3rem;
          }

          .invoice-table {
            thead th:first-of-type {
              border-top-left-radius: 0.3rem;
              border-bottom-left-radius: 0.3rem;
            }

            thead th:last-of-type {
              border-top-right-radius: 0.3rem;
              border-bottom-right-radius: 0.3rem;
            }

            thead tr {
              background: ${tinycolor(accentColor).setAlpha(0.9).toRgbString()};
              color: white;
            }
            tbody td {
              //border-bottom: 1px solid ${tinycolor(accentColor)
                .setAlpha(0.08)
                .toRgbString()};

              border-bottom: 1px solid rgba(44, 53, 77, 0.12);
            }
            tbody tr:last-of-type td {
              border-bottom: none;
            }
            .invoice-totals td {
              border-bottom: none;
            }
            .invoice-totals {
              td:not(:first-of-type) {
                // color: ${colors[8].toRgbString()};
                background: ${tinycolor(accentColor)
                  .setAlpha(0.035)
                  .toRgbString()};
              }
               td:nth-child(2) div {
              padding-left: 0;
              margin-left: 16px;
            }
            td:last-child div {
              padding-right: 0;
              margin-right: 16px;
            }
              tr {
                &:first-of-type td div {
                  padding-top: 1.1rem;
                }
                &:last-of-type td div {
                  padding-bottom: 1rem;
                }
              }
            }
            .subtotal-amount td:not(:first-of-type) div {
              border: none;
            }
          }
        `}
      />
      <Header {...props} />
      <Main {...props} />
      <Footer {...props} />
    </Base>
  )
}

export default Template2
